import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error",
  "use": "icon-error-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-error\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12,11.29l1.41-1.41.71.71L12.71,12l1.41,1.41-.71.71L12,12.71l-1.41,1.41-.71-.71L11.29,12,9.88,10.59l.71-.71ZM12,16a4,4,0,1,0-4-4A4,4,0,0,0,12,16Zm0,1a5,5,0,1,1,5-5A5,5,0,0,1,12,17Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol